import React from 'react';
import { useParams, NavLink, Link } from "react-router-dom";
import '../assets/Home.css';
import SingleCustomization from '../routes/singleCustomization';

function NavCustomization({items}) {
    const {idx} = useParams();
    const allItems = Object.entries(items[idx].customizations);
    const oneItem = Object.values(allItems);

    return (
    <div id="nav_customization">
        <div id="breadcrumb">
            <ul>
                <Link to="/" >Home</Link> {">"}
                <Link to="/customizations"> Customizations</Link> {"> "}
                <Link to="#" style={{color:"black"}}> {items[idx].title}</Link>
            </ul>
        </div>
        <div className="display_customizations">
            <div className='left_nav'>
                <div>
                    <div className="categ_title">
                        {/* <img alt={items[idx].title} src={items[idx].icon} />  */}
                        <h3> {items[idx].title}</h3>
                    </div>
                    <nav>
                        <ul>
                        {oneItem.map((item, index) =>
                            <div key={index}>
                                <li>
                                    <NavLink to={`${item[0]}`} activeclassnav="active">
                                        {item[1].name}
                                    </NavLink>
                                </li>
                            </div>
                        )}
                        </ul>
                    </nav>
                </div>
            </div>
            <SingleCustomization items={items[idx].customizations}/>
        </div>
    </div>
    );
}
export default NavCustomization;